import { createContext } from 'react'
import { PromptHandler } from 'types'

export const PromptContext = createContext<PromptHandler | undefined>(
  undefined,
)
